export class YandexAddressDto {
  address: string;
  postalCode: string;
  area: string;
  province: string;
  street: string;
  house: string;
  latitude: number;
  longitude: number;
}